import { PhasrRestrictedProfilesViewWebComponent } from './component/PhasrRestrictedProfilesViewWebComponent';

export { PhasrRestrictedProfilesViewWebComponent };
